
import React, { useContext, useEffect, useRef } from 'react';
import MessageContext from '../context/messageContext';
import Popup from './popup';

const Message = ({show = false , imagePath = '/assets/images/delivery.svg' ,title = ''}) => {
    const popRef = useRef();
    const {notify} = useContext(MessageContext);

    useEffect(() => {
        function handleClickOutside(event) {
            if (popRef.current && show === true) {
                notify({show:false});
            }
        }
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    },[show]);

    return (
            <Popup
                show={show}>
                <div ref={popRef} className='h-full w-full'>
                    <div className='flex items-center justify-center w-full h-full'>
                        <div className="message">
                            <img src={imagePath} alt='alert image' />
                            <div className="message-title">{title}</div>
                        </div>
                    </div>
                </div>
            </Popup>
    );
};
export default Message;


